import React from 'react';
import { useLocation } from 'react-router-dom';
import { Paper, Grid, Typography } from '@material-ui/core';

const LocationDetails = () => {
  const location = useLocation(); // Get location object
  const queryParams = new URLSearchParams(location.search);
  const locationData = JSON.parse(decodeURIComponent(queryParams.get("data")));

  if (!locationData) {
    return <div>No data available</div>; // Handle the case where no data is passed
  }

  const statusStyle = {
    color: locationData.isActive ? 'green' : 'red'
  };

  const verifiedStyle = {
    color: locationData.isVerified ? 'green' : 'red'
  };

  const fieldStyle = {
    marginBottom: '10px' // Space between individual fields
  };
  return (
    <div style={{backgroundColor: '#F2F2F2', height: 'calc(100vh - 144px)', margin: '50px'}}>
      {/* Header with Back button and code */}
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', marginTop: '80px'}}>
        <Typography variant="h6" style={{ }}>
          <span style={{ fontWeight: '500', fontSize: '0.85em' }}>Code:</span>
          <b style={{ fontWeight: '900', color: '#298BC1', marginLeft: '8px' }}>{locationData.id}</b> {/* More bold, different color */}
        </Typography>
      </div>

      {/* Main Paper containing location details */}
      <Paper style={{ padding: '20px', backgroundColor: '#FFFFFF' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ marginBottom: '15px', fontSize: '18px' }}>
            <b> {locationData.placeName} </b>
          </div>
        </div>
        <Grid container spacing={3} alignItems="center" justifyContent="flex-start">

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Status
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{...statusStyle, fontWeight: 'bold'}}>
                  {locationData.isActive ? 'Active' : 'Inactive'}
                </span>
              </div>
            </Typography>
          </div>
        </Grid>
        
        
        
        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Type
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.type || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Locality
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.locality || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Zip Code
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.zipCode || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              State
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.state || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              City:
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.city || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Latitude
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.latitude || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Longitude
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.longitude || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>
        
        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Code
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.code || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Created At
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{(new Date(locationData.createdAt).toLocaleString()) || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Updated At
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{(new Date(locationData.updatedAt).toLocaleString()) || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Country
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.country || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Unlocode
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{color: 'black' ,  fontWeight: 'bold' }}>
                  <b>{locationData.unlocode || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              IATA Code
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{color: 'black' ,  fontWeight: 'bold' }}>
                  <b>{locationData.iataCode || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Verified
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{...verifiedStyle,  fontWeight: 'bold' }}>
                  <b>{locationData.isVerified ? 'Verified' : 'Not Verified'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Comment
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.comment || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} sm={2}>
          <div style={fieldStyle}>
            <Typography variant="body1">
              Application Namespace
              <br />
              <div style={{ marginTop: '5px' }}>
                <span style={{ fontWeight: 'bold', color: 'black' }}>
                  <b>{locationData.applicationNamespace || 'N/A'}</b>
                </span>
              </div>
            </Typography>
          </div>
        </Grid>
        </Grid>
      </Paper>
    </div>
  );
};

export default LocationDetails;
